import React, { useEffect, useState } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { REACT_APP_KSHEMA_POC2, REACT_APP_VAM_CONTEXT_APPROVAL, REACT_APP_VAM_CONTEXT_CALCULATE, REACT_APP_VAM_ENDPOINT } from "../urls";
import { editModeOn, getChannelName, getFromDecreaptLocalStorage } from "../utilFunctions";
import NoDataFound from "../utilsComponent/noDataFound";
import { toast } from "react-toastify";
import { format } from "date-fns";
import ListsPagination from "../utilsComponent/ListsPagination";
import { axiosRequest } from "../service";
import { functionalities, PAGE_NAME_KEYS, PMFBY } from "../consts";

const BulkApproval = (props) => {
    const {productNames} = props
    const navigate = useNavigate();
    const defaultSearch = {
        productName: "",
        claimId: "",
        policyId: "",
        state: "",
        district: "",
        iuName: "",
        ingestionType: ""
    }
    const [searchFields, setsearchFields] = useState(defaultSearch)
    const [statesList, setStatesList] = useState([])
    const [districtList, setDistrictList] = useState([])
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedState, setSelectedState] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedIngestionTypeList, setSelectedIngestionTypeList] = useState("");
    const [selectedIU, setSelectedIU] = useState("");
    const [selectedIngestionType, setSelectedIngestionType] = useState("");
    const [selectedClaimsList, setSelectedClaimsList] = useState([])
    const [claimsList, setClaimsList] = useState([])
    const [comments, setComments] = useState("")
    const [buttonsStatus, setButtonsStatus] = useState("Bulk")
    const [showRejectPopover, setShowRejectPopover] = useState(false);
    const [showApprovePopover, setShowApprovePopover] = useState(false);
    const [bulkApprovaltext, setBulkApprovaltext] = useState("")
    const [claimIdList, setclaimIdList] = useState([])
    const [showClaimIdModal, setShowClaimIdModal] = useState(false)
    const [currentItems, setCurrentItems] = useState([])
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")

    useEffect(() => {
        getStatesList()
        getUINameList()
        getIngestionTypeList()
    }, [])

    const searchClaimList = () => {
        if ((searchFields.productName == "" ||searchFields.productName == undefined) && searchFields.claimId == "" && searchFields.policyId == "" && (searchFields.state == '' || searchFields.state == undefined) && (searchFields.district == "" || searchFields.district == undefined) && searchFields.iuName == "" && searchFields.ingestionType == "") {
            toast.error("Please Input a search Parameter");
            return;
        }
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_APPROVAL}/searchClaim`, searchFields).then(data => {
            const listsUpadted = data.data.map(list => {
                return {
                    ...list,
                    checked: false
                }
            })
            setClaimsList(listsUpadted)
        }).catch(error => {
            console.log(error)
        })
    }
    const getStatesList = () => {
        axiosRequest().get(`${REACT_APP_KSHEMA_POC2}/states`)
            .then(response => {
                const states = response.data.States.flat(Infinity);
                const sortedStates = sortStatesAlphabetically(states);
                const mappedStates = sortedStates.map(state => ({
                    label: state,
                    value: state
                }));
                setStatesList(mappedStates);
            })
            .catch(error => {
                console.log('Error fetching states:', error);
            });
    }
    const sortStatesAlphabetically = (states) => {
        return [...states].sort((a, b) => a.localeCompare(b));
    };
    const getDiscrictList = (state) => {
        axiosRequest().get(`${REACT_APP_KSHEMA_POC2}/districts/${state}`).then(data => {
            setDistrictList(data.data.Districts.flat("Infinity").map(list => {
                return {
                    label: list,
                    value: list
                }
            }))
        }).catch(error => {
            console.log(error)
        })
    }
    const getIngestionTypeList = (state) => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_APPROVAL}/getIngestionTypeList`).then(data => {
            setSelectedIngestionType(data.data.map(list => {
                return {
                    label: list,
                    value: list
                }
            }))
        }).catch(error => {
            console.log(error)
        })
    }
    const getUINameList = (state) => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_APPROVAL}/getIUNameList`).then(data => {
            setSelectedIU(data.data.map(list => {
                return {
                    label: list,
                    value: list
                }
            }))
        }).catch(error => {
            console.log(error)
        })
    }

    const handleSelectAll = (status) => {
        let updatedArray = []
        if (status) {
            updatedArray = claimsList.map(obj => ({ ...obj, checked: false }));
        } else {
            updatedArray = claimsList.map(obj => ({ ...obj, checked: true }));
        }
        setClaimsList([...updatedArray])
    };

    const handleSelect = (claimList) => {
        claimsList.forEach(obj => {
            if (obj.claimNumber === claimList.claimNumber) {
                obj.checked = !obj.checked;
            }
            setClaimsList([...claimsList])
        });
    };

    const handleRejectClick = () => {
        setShowRejectPopover(!showRejectPopover);
    };

    const handleApproveClick = () => {
        const unAssignedClaims = claimsList
            .filter(list => list.checked && (list.assignedTo == "Unassigned" || list.assignedTo == ''))
            .map(list => list.claimNumber);
          if(unAssignedClaims.length > 0) {
            toast.error(`Unable to proceed further because the following claims are not assigned to claim handlers:${unAssignedClaims}`)
                return;
        }
        // showApprovePopover && searchClaimList()
        setShowApprovePopover(!showApprovePopover);
    };

    const handleRejectPopoverClose = () => {
        setShowRejectPopover(false);
    };

    const handleApprovePopoverClose = () => {
        setShowApprovePopover(false);
    };
    const navigateUTRUpload = () => {
        navigate(`/dashboard/${PAGE_NAME_KEYS.UTR_UPLOAD}`);
    }

    const handleSubmitClickBulkApprove = () => {
        if (!comments) {
            toast.error("Please Enter Remarks.")
            return
        }
        axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_CALCULATE}/verifyGovtCalculationBulk`, {
            "claimIds": claimsList.filter(list => list.checked).map(list => list.claimNumber),
            "approverName": roleDataCookie.userID,
            "comments": comments
        }).then(res => {
            if(res.data.readyForApproval && res.data.calcVerification){
                axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_APPROVAL}/bulk-approve`, {
                    "claimIds": claimsList.filter(list => list.checked).map(list => list.claimNumber),
                    "approverName": roleDataCookie.userID,
                    "comments": comments
                }).then(data => {
                    setBulkApprovaltext(data.data)
                }).catch(error => {
                    console.log(error)
                })
            }else{
                setclaimIdList(res.data.claimIds)
                setShowClaimIdModal(true)
                handleApproveClick()
            }          
        }).catch(error => {
            console.log(error)
        })
    };
    const resetSearchFields = () => {
        setsearchFields(defaultSearch); 
        setClaimsList([])
    }
    return (
        <section className="p-4">
            <div className="border rounded p-4 px-1">
                <div className="d-md-flex align-items-center justify-content-around">
                    <div className="row">
                        <div className="form-group w-20 col-3">
                            <label for="exampleInputPassword1">Product Name</label>
                            <Select id="exampleInputPassword1" options={productNames}
                                classNamePrefix="bg-gray" placeholder="Select Kshema Product"
                                value={searchFields.productName ? { label: searchFields.productName } : null}
                                onChange={(data) => {
                                    setsearchFields({
                                        ...searchFields,
                                        productName: data?.label,
                                        ingestionType : data?.label !== PMFBY ? "" : searchFields.ingestionType
                                    })
                                }}
                                isClearable = {true}
                            />
                        </div >
                        <div className="form-group w-20 col-3">
                            <label for="exampleInputPassword1">Claim ID</label>
                            <input type="text" className="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Claim ID" value={searchFields.claimId} onChange={(e) => {
                                 if(/[^A-Za-z\d]/.test(e.target.value)){
                                    return
                                   }
                                setsearchFields({
                                    ...searchFields,
                                    claimId: e.target.value,
                                })
                            }} />
                        </div >
                        <div className="form-group w-20 col-3">
                            <label for="exampleInputPassword1">Policy ID</label>
                            <input type="text" maxLength={50} className="form-control bg-gray" id="exampleInputPassword1" placeholder="Enter Policy ID" value={searchFields.policyId} onChange={(e) => {
                                 if(/[^A-Za-z\d]/.test(e.target.value)){
                                    return
                                   }
                                setsearchFields({
                                    ...searchFields,
                                    policyId: e.target.value,
                                })
                            }} />
                        </div >
                        <div className="form-group w-20 col-3">
                            <label for="exampleInputPassword1">State</label>
                            <Select id="exampleInputPassword1" options={statesList}
                                classNamePrefix="bg-gray" placeholder="Select State"
                                value={searchFields.state ? { label: searchFields.state, value: searchFields.state } : null}
                                onChange={(data) => {
                                    getDiscrictList(data?.value)
                                    setsearchFields({
                                        ...searchFields,
                                        state: data?.value,
                                    })
                                }}
                                isClearable = {true}
                            />
                        </div >
                        <div className="form-group w-20 col-3 mt-3">
                            <label for="exampleInputPassword1">District</label>
                            <Select id="exampleInputPassword2" options={districtList}
                                classNamePrefix="bg-gray" placeholder="Select District"
                                isDisabled={!searchFields.state}
                                value={searchFields.district ? { label: searchFields.district, value: searchFields.district } : null}
                                onChange={(data) => {
                                    setsearchFields({
                                        ...searchFields,
                                        district: data?.value,
                                    })
                                }}
                                isClearable = {true}
                            />
                        </div >
                        <div className="form-group w-20 col-3 mt-3">
                            <label for="exampleInputPassword1">IU Name</label>
                            <Select id="exampleInputPassword1" options={selectedIU}
                                classNamePrefix="bg-gray" placeholder="Select IU Name"
                                value={searchFields.iuName ? { label: searchFields.iuName, value: searchFields.iuName } : null}
                                onChange={(data) => {
                                    setsearchFields({
                                        ...searchFields,
                                        iuName: data?.value ?? "",
                                    })
                                }}
                                isClearable = {true}
                            />
                        </div >
                        <div className="form-group w-20 col-3 mt-3">
                            <label for="exampleInputPassword1">Ingestion Type</label>
                            <Select id="exampleInputPassword1" options={selectedIngestionType}
                                classNamePrefix="bg-gray" placeholder="Select Ingestion Type"
                                value={searchFields.ingestionType ? { label: searchFields.ingestionType, value: searchFields.ingestionType } : null}
                                onChange={(data) => {
                                    setsearchFields({
                                        ...searchFields,
                                        ingestionType: data?.value ?? "",
                                    })
                                }}
                                isDisabled={searchFields.productName && searchFields.productName !== PMFBY}
                                isClearable = {true}
                            />
                        </div >
                    </div>
                </div>
                <div className="row">
                    <div className="form-group">
                        <button 
                            className="btn btn-success m-3 mb-0 px-4 mt-4"
                            onClick={() => {
                                searchClaimList();
                                setClaimsList([]);
                            }}
                        >
                            Search
                        </button>
                        <button className="btn btn-outline-success m-3 mb-0 px-4 mt-4" onClick={() => resetSearchFields()}>Reset</button>
                    </div>
                </div>

            </div>

            <div>
                {
                    claimsList && claimsList.length > 0 && (
                        <Row>
                            <Col xs={11}>
                                <h2
                                    className="heading_h2"
                                >
                                    Search Results
                                </h2>
                            </Col>
                            {
                                claimsList.length > 0 && (
                                    <>
                                        {/* <Col xs={1}>
                      <Button variant="mt-4" className="btn btn-outline-danger mt-4" onClick={handleRejectClick}>
                        Reject
                      </Button>
                    </Col> */}

                                        <Col xs={1}>
                                            {editModeOn(functionalities.CLAIM_BULK_PROCESS_TAB) &&
                                                <Button variant="mt-4" className="btn btn-outline-success mt-4 ms-4" disabled={!claimsList.filter(list => list.checked).length} onClick={() => { handleApproveClick(); setBulkApprovaltext("") }}>
                                                    Approve
                                                </Button>
                                            }
                                        </Col>
                                    </>
                                )
                            }
                        </Row>
                    )
                }
            </div>
            {
                claimsList && claimsList.length > 0 ? (
                    <>
                        <table id="claim_historyclaim">
                            <tbody>
                                <tr>
                                    {editModeOn(functionalities.CLAIM_BULK_PROCESS_TAB) && (
                                        <th>
                                            {/* Select */}
                                            <input
                                                type="checkbox"
                                                checked={claimsList.length === claimsList.filter(list => list.checked).length}
                                                onChange={() => {
                                                    handleSelectAll(claimsList.length === claimsList.filter(list => list.checked).length);
                                                }}
                                            />
                                        </th>
                                    )}
                                    <th>
                                        Claim Number
                                    </th>
                                    <th>
                                        Policy Number
                                    </th>
                                    <th>
                                        Farmer Name
                                    </th>
                                    <th>
                                        Source
                                    </th>
                                    <th>
                                        Product Name
                                    </th>
                                    <th>
                                        Intimated Date& Time
                                    </th>
                                    <th>
                                        Contact Number
                                    </th>
                                    <th>
                                        Alternative Contact Number
                                    </th>
                                    <th>
                                        Sub Status
                                    </th>
                                    <th>
                                        IU Name
                                    </th>
                                    <th>
                                        Batch ID
                                    </th>
                                    <th>
                                        Affected Area%
                                    </th>
                                    <th>
                                        Loss%
                                    </th>
                                    <th>
                                        Net Payout
                                    </th>
                                    <th>Assigned To</th>
                                </tr>
                                {currentItems.map((result, index) => (
                                    <tr key={index}>
                                        {editModeOn(functionalities.CLAIM_BULK_PROCESS_TAB) && (
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={result.checked}
                                                    onChange={() => { handleSelect(result) }}
                                                />
                                            </td>
                                        )}
                                        <td style={{ textDecoration: 'underline', color: '#198754' }}>{result.claimNumber}</td>
                                        <td>{result.policyNumber}</td>
                                        <td>{result.farmerName}</td>
                                        <td>{getChannelName(result.source)}</td>
                                        <td>{result.productName}</td>
                                        <td>{format(new Date(result.intimatedDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a')}</td>
                                        <td>{result.contactNumber}</td>
                                        <td>{result.alternativeContactNumber}</td>
                                        {result.subStatus === 'Rejected' ?
                                            <td style={{ color: 'red' }}> {result.subStatus}</td>
                                            :
                                            <td style={{ color: '#48d2ff' }}> {result.subStatus}</td>
                                        }
                                        <td>{result.iuName}</td>
                                        <td>{result.batchID}</td>
                                        <td>{result.affectedArea}</td>
                                        <td>{result.loss}</td>
                                        <td>{result.netPayout}</td>
                                        <td>{result.assignedTo}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <ListsPagination setCurrentItems={setCurrentItems} lists={claimsList}/>                   
                    </>
                ) : <NoDataFound text="No Data Found" />
            }
            {showClaimIdModal &&
                <Modal show={showClaimIdModal} isOpen={showClaimIdModal} centered={true} backdrop={'static'}>
                    {/* <ModalHeader toggle={() => setShowClaimIdModal(!showClaimIdModal)}>Reject</ModalHeader> */}
                    <ModalBody>
                        <label>Calculation approval could not be completed due to a calculation discrepancy. The net payout has been updated for the claims with discrepancies. List of claims:</label>
                        <div className="mt-3">
                            {
                                claimIdList && claimIdList.length > 0 && claimIdList.map((list,index) => (
                                    <div>{index+1}.<span className="ms-2">{list}</span></div>
                                ))
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter style={{ justifyContent: 'center' }}>
                        <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={() => {setShowClaimIdModal(false);setShowApprovePopover(false);setShowRejectPopover(false);resetSearchFields()}}>Ok</Button>
                    </ModalFooter>
                </Modal>
            }

            {showRejectPopover &&
                <Modal show={showRejectPopover} isOpen={showRejectPopover} toggle={handleRejectClick} centered={true} backdrop={'static'}>
                    <ModalHeader toggle={handleRejectClick}>Reject</ModalHeader>
                    <ModalBody>
                        <label><h6>Remarks <text style={{ color: 'red' }}>*</text></h6></label>
                        <textarea
                            placeholder=""
                            style={{ width: '100%', height: '100px' }}
                        />
                    </ModalBody>
                    <ModalFooter style={{ justifyContent: 'center' }}>
                        <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={handleRejectClick}>Cancel</Button>
                        <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={handleSubmitClickBulkApprove}>Submit</Button>
                    </ModalFooter>
                </Modal>
            }

            {showApprovePopover &&

                <Modal show={showApprovePopover} isOpen={showApprovePopover} toggle={handleApproveClick} centered={true} backdrop={'static'}>
                    <ModalHeader toggle={handleApproveClick}>Approve</ModalHeader>
                    <ModalBody>
                        {
                            bulkApprovaltext ? (
                                <>
                                    <a className="center">
                                        <img src="../kshemaImages/Star.png" alt="Success" width="132px" height="132px" className="center" />
                                    </a>
                                    <p className="claim_success">{bulkApprovaltext}</p>
                                </>
                            ) : (
                                <>
                                    <label><h6>Remarks<span className="asteriskPolicy">*</span></h6></label>
                                    <textarea
                                        placeholder=""
                                        style={{ width: '100%', height: '100px' }}
                                        onChange={(e) => setComments(e.target.value)}
                                    />
                                </>
                            )
                        }
                    </ModalBody>
                    <ModalFooter style={{ justifyContent: 'center' }}>
                        {bulkApprovaltext ? (
                            <Button color="secondary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={() => {handleApproveClick();resetSearchFields()}}>OK</Button>
                        ) : (<>
                            <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={() => {handleApproveClick();resetSearchFields()}}>Cancel</Button>

                            <Button color="primary" style={{ borderColor: 'green', backgroundColor: 'transparent', color: 'green' }} onClick={handleSubmitClickBulkApprove}>Submit</Button>
                        </>)}
                    </ModalFooter>
                </Modal>
            }
        </section>
    )
}
export default BulkApproval;